export const FEATURE_FLAGS = {
  ENABLE_OPENGOV_SSO_LOGIN: 'product-gab-ui-opengov-sso-login',
  ENABLE_ADD_USER_WIZARD: 'product-gab-ui-add-user-wizard',
  PRINT_RECORD_DELAY: 'product-gab-ui-print-record-delay',
  ENABLE_ENTITY_LEVEL_TOP_LEVEL_ROLE: 'product-gab-ui-entity-level-top-level-role',
  ENABLE_CHILD_TABLE: 'product-gab-ui-child-table',
  ENABLE_IMPORT_DEMO: 'product-gab-ui-import-demo',
  ENABLE_IFRAME_GUARD: 'product-gab-ui-iframe-guard',
  ENABLE_DATA_TABLE_ACCESSIBILITY: 'product-gab-ui-datatable-accessibility',
  ENABLE_AUTH_ACCESSIBILITY:'product-gab-ui-authentication-accessibility',
  ENABLE_GAB_IMPORT_HEALTH_CHECK: 'product-gab-ui-gabimport-healthcheck',
  FIX_FLEXMONSTER_CHART_VIEW: 'product-gab-ui-fix-flexmonster-chart-view',
  ENABLE_CALENDAR_ACCESSIBILITY: 'product-gab-ui-calendar-accessibility',
  ENABLE_MAP_ACCESSIBILITY: 'product-gab-map-accessibility',
  GAB_PRODUCTS_LINK_ACCESSIBILITY: 'gab-product-links-accessibility',
  GAB_PRODUCT_DASHBOARD_HEADING_ACCESSIBILITY: 'gab-product-dashboard-heading-accessibility',
  PRESERVE_FORM_ON_EMBEDDED_TABLE_SAVE: 'product-gab-ui-preserve-form-embedded-table',
  ENABLE_FLEXMONSTER_KEYBOARD_MODE: 'product-gab-ui-flexmonster-keyboard-mode',
  ENABLE_UUID_FIELD_TYPE: 'product-gab-uuid-fieldtype',
  ENABLE_MODAL_OVERFLOW_FIX: 'product-gab-ui-modal-overflow-fix',
  ENABLE_NOTIFICATION_DROPDOWN_VALIDATION: 'product-gab-ui-notification-dropdown-validation',
  ENABLE_ADD_USER_UX_IMPROVEMENTS: 'product-gab-ui-add-user-ux-improvements',
  DISABLE_USER_WHEN_GAB_ENTITLEMENT_REMOVED: 'product-gab-disable-user-when-gab-entitlement-removed-from-control-panel',
  ENABLE_REFRESH_TOKEN: 'gab-product-refresh-token-enabled',
  ENABLE_IMPORT_DOMAIN_OBJECT: 'product-gab-ui-import-domain-object',
  ENABLE_OG_INSIGHTS_CHARTS: 'product-gab-ui-og-insights-charts',
  ENABLE_NEW_FORM_COLLAPSIBLE: 'product-gab-ui-enable-new-form-collapsible',
  ENABLE_OG_AUTH0_REFRESH_TOKEN_FALLBACK: 'gab-product-ui-og-auth0-refresh-token-fallback-enabled',
  ENABLE_RUNTIME_SECRETS: 'product-gab-ui-runtime-secrets',
  ENABLE_NEW_NAV_SIDEBAR: 'product-gab-ui-new-nav-sidebar',
  HIDE_LOGOUT_IN_PSP_SHELL: 'product-gab-ui-hide-logout-when-in-psp-shell',
  ENABLE_FILE_MISSING_TOOLTIP: 'product-gab-fe-filemissing-tooltip',
  ENABLE_CUSTOM_BUTTON_DISABLED: 'product-gab-ui-custom-button-disabled',
  ENABLE_ACCESSIBLE_FORM_TABS: 'product-gab-ui-enable-accessible-form-tabs',
  ENABLE_FORM_DROPDOWN_NG_SELECT: 'product-gab-ui-form-dropdowns-ng-select',
  ENABLE_A11Y_FILE_INPUT: 'product-gab-ui-a11y-file-input',
  ENABLE_SINGLE_APP_DIRECT_LOGIN: 'product-gab-ui-single-app-direct-login',
  ENABLE_READONLY_FILE_ATTACHMENT_FIX: 'product-gab-ui-readonly-file-attachment-fix',
  // Overrides
  APPTABLE_SUMMARY_FIELD_LIMITS: 'product-gab-ui-apptable-summary-field-limits',

  ENABLE_SUMMARY_FIELD_ACCESSIBILITY: 'product-gab-ui-summary-field-accessibility',
  PDF_FORM_SAVE_ON_EDIT_FIX: 'product-gab-ui-pdf-form-save-on-edit-fix',
  ENABLE_EDIT_USER_PHONE_NUMBER_FIX: 'product-gab-ui-edit-user-phone-number-fix',
  ENABLE_IMPERSONATE_USER_ISSUE_FIX: 'product-gab-ui-impersonate-user-issue-fix',
};
